// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"layout_innerWrapper__nZF6g"};